import { jsx as _jsx } from "react/jsx-runtime";
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputAdornment, styled, TextField } from '@mui/material';
export const PentairFilterSearch = styled(TextField)(({ theme }) => ({
    maxWidth: '240px',
    margin: 0,
    paddingTop: 10,
    paddingBottom: 9,
    minHeight: 48,
    '& .MuiInputBase-input': {
        textTransform: 'uppercase',
        fontSize: '0.875rem',
        fontWeight: 600,
        color: theme.palette.brightBlue.main,
        paddingLeft: '8px',
        '&::placeholder': {
            color: theme.palette.silverGray.main,
            fontWeight: 400,
        },
    },
    '& .MuiInputBase-root:before': {
        display: 'none',
    },
    '& .MuiInputBase-root:after': {
        display: 'none',
    },
}));
PentairFilterSearch.defaultProps = {
    InputProps: {
        fullWidth: true,
        startAdornment: (_jsx(InputAdornment, { position: "start", sx: { color: 'silverGray.main', marginLeft: '16px' }, children: _jsx(FontAwesomeIcon, { icon: faMagnifyingGlass, fontSize: "1rem", color: 'inherit' }) })),
    },
};
export default PentairFilterSearch;
